import { ComponentProps } from 'react';
import { Modal, Token, Typography, Wrapper } from '@screentone/core';

import { Diff } from 'components';
import styles from './PublishHistory.module.scss';
import { HistoryContent } from './types';

interface CompareRevisionsModalProps<T extends HistoryContent> {
  isOpen: boolean;
  onDismiss: () => void;
  renderNode: ComponentProps<typeof Modal>['renderNode'];
  currentItem: T;
  prevRevision: T | undefined;
  isETTimestamp: boolean;
  formatTimestamp: (timestamp: string | number | Date) => string;
  formatTimestampET: (timestamp: string | number | Date) => string;
}

export const CompareRevisionsModal = <T extends HistoryContent>({
  isOpen,
  onDismiss,
  renderNode,
  currentItem,
  prevRevision,
  isETTimestamp,
  formatTimestamp,
  formatTimestampET
}: CompareRevisionsModalProps<T>) => {
  if (!isOpen) return null;

  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Modal onDismiss={onDismiss} renderNode={renderNode} fullWidth padding={{ all: 'md' }}>
      <Wrapper padding={{ all: 'lg' }}>
        <Modal.Title>
          {prevRevision ? (
            <Wrapper>
              <Typography variant="header2">Comparing Revisions</Typography>
              <Wrapper className={styles.revisionRows}>
                {!isETTimestamp && (
                  <>
                    <Token>Eastern Timezone</Token>
                    <Typography variant="label1" margin={{ bottom: 'none' }}>
                      {formatTimestampET(prevRevision.metadata.publishUtc ?? 0)} vs{' '}
                      {formatTimestampET(currentItem.metadata.publishUtc ?? 0)}
                    </Typography>
                  </>
                )}
                <Token>Preferred Timezone</Token>
                <Typography variant="label1" color="asphalt" margin={{ bottom: 'none' }}>
                  {formatTimestamp(prevRevision.metadata.publishUtc ?? 0)} vs{' '}
                  {formatTimestamp(currentItem.metadata.publishUtc ?? 0)}
                </Typography>
              </Wrapper>
            </Wrapper>
          ) : (
            <Typography variant="header2">No previous revision to compare</Typography>
          )}
        </Modal.Title>
        {prevRevision && <Diff oldData={prevRevision} newData={currentItem} />}
      </Wrapper>
    </Modal>
  );
};
